import React from "react";
import ReactDOM from "react-dom/client";
import "@hid-galaxy-ui/galaxy-css/galaxy.css";
import "./index.css";
import "./media-queries.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TENANT_ID } from "./utils/common";
import { getTenantBranding } from "./config/tenantBranding";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

document.title = getTenantBranding(TENANT_ID).pageTitle;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
